import { PayloadAction } from '@reduxjs/toolkit';
import { ISettingsState } from './settings-interface';

const reducer = {
  setUserAccount: (
    state: ISettingsState,
    action: PayloadAction<ISettingsState['userAccount']>
  ) => {
    state.userAccount = action.payload;
  },
  setBootstrapApp: (
    state: ISettingsState,
    action: PayloadAction<ISettingsState['bootstrap']>
  ) => {
    state.bootstrap = action.payload;
  },
  setPermissions: (
    state: ISettingsState,
    action: PayloadAction<ISettingsState['permissions']>
  ) => {
    state.permissions = action.payload;
  },
  setBusinessArea: (
    state: ISettingsState,
    action: PayloadAction<ISettingsState['businessArea']>
  ) => {
    state.businessArea = action.payload;
  },
  setService: (
    state: ISettingsState,
    action: PayloadAction<ISettingsState['service']>
  ) => {
    state.service = action.payload;
  },
  setCurrentFile: (
    state: ISettingsState,
    action: PayloadAction<ISettingsState['currentFile']>
  ) => {
    state.currentFile = action.payload;
  },
  setDisclaimerModal: (
    state: ISettingsState,
    action: PayloadAction<ISettingsState['isDisclaimerModal']>
  ) => {
    state.isDisclaimerModal = action.payload;
  },
  setIsLoading: (
    state: ISettingsState,
    action: PayloadAction<ISettingsState['isLoading']>
  ) => {
    state.isLoading = action.payload;
  },
  setHash: (
    state: ISettingsState,
    action: PayloadAction<ISettingsState['hash']>
  ) => {
    state.hash = action.payload;
  },
  setCurrentSummary: (
    state: ISettingsState,
    action: PayloadAction<ISettingsState['currentSummary']>
  ) => {
    state.currentSummary = action.payload;
  },
  setSummaryEdited: (
    state: ISettingsState,
    action: PayloadAction<ISettingsState['summaryEdited']>
  ) => {
    state.summaryEdited = action.payload;
  },
  setFeedbackConfirmation: (
    state: ISettingsState,
    action: PayloadAction<ISettingsState['isFeedbackConfirmation']>
  ) => {
    state.isFeedbackConfirmation = action.payload;
  },
  setRegenerateExtraction: (
    state: ISettingsState,
    action: PayloadAction<ISettingsState['regenerateExtraction']>
  ) => {
    state.regenerateExtraction = action.payload;
  },
  setGeneratingExtraction: (
    state: ISettingsState,
    action: PayloadAction<ISettingsState['isGeneratingExtraction']>
  ) => {
    state.isGeneratingExtraction = action.payload;
  },
  setEmailChain: (
    state: ISettingsState,
    action: PayloadAction<ISettingsState['emailChain']>
  ) => {
    state.emailChain = action.payload;
  },
  setBetaWelcomeModal: (
    state: ISettingsState,
    action: PayloadAction<ISettingsState['isBetaWelcomeModal']>
  ) => {
    state.isBetaWelcomeModal = action.payload;
  },
  setCurrentSupportPath: (
    state: ISettingsState,
    action: PayloadAction<ISettingsState['currentSupportPath']>
  ) => {
    state.currentSupportPath = action.payload;
  },
  setSelectedHighlight: (
    state: ISettingsState,
    action: PayloadAction<ISettingsState['selectedHighlight']>
  ) => {
    state.selectedHighlight = action.payload;
  },
  setHighlightCoords: (
    state: ISettingsState,
    action: PayloadAction<ISettingsState['highlightCoords']>
  ) => {
    state.highlightCoords = action.payload;
  },
  setShowHighlights: (
    state: ISettingsState,
    action: PayloadAction<ISettingsState['showHighlights']>
  ) => {
    state.showHighlights = action.payload;
  },
  setIsSelectLanguageModal: (
    state: ISettingsState,
    action: PayloadAction<ISettingsState['isSelectLanguageModal']>
  ) => {
    state.isSelectLanguageModal = action.payload;
  },
  setSelectedLanguage: (
    state: ISettingsState,
    action: PayloadAction<ISettingsState['selectedLanguage']>
  ) => {
    state.selectedLanguage = action.payload;
  },
  setInputSize: (
    state: ISettingsState,
    action: PayloadAction<ISettingsState['inputSize']>
  ) => {
    state.inputSize = action.payload;
  },
  setIsEstimatedCostModal: (
    state: ISettingsState,
    action: PayloadAction<ISettingsState['isEstimatedCostModal']>
  ) => {
    state.isEstimatedCostModal = action.payload;
  },
  setCoverageCheckV2Id: (
    state: ISettingsState,
    action: PayloadAction<ISettingsState['coverageCheckV2Id']>
  ) => {
    state.coverageCheckV2Id = action.payload;
  },
  setCoverageCheckV2Files: (
    state: ISettingsState,
    action: PayloadAction<ISettingsState['coverageCheckV2Files']>
  ) => {
    state.coverageCheckV2Files = action.payload;
  },
  setUserRoles: (
    state: ISettingsState,
    action: PayloadAction<ISettingsState['userRoles']>
  ) => {
    state.userRoles = action.payload;
  },
  setUserBusinessUnits: (
    state: ISettingsState,
    action: PayloadAction<ISettingsState['userBusinessUnits']>
  ) => {
    state.userBusinessUnits = action.payload;
  },
  setSelectedBusinessUnit: (
    state: ISettingsState,
    action: PayloadAction<ISettingsState['selectedBusinessUnit']>
  ) => {
    state.selectedBusinessUnit = action.payload;
  },
  setSelectedDocuments: (
    state: ISettingsState,
    action: PayloadAction<ISettingsState['selectedDocuments']>
  ) => {
    state.selectedDocuments = action.payload;
  },
  setCanSelectDocuments: (
    state: ISettingsState,
    action: PayloadAction<ISettingsState['canSelectDocuments']>
  ) => {
    state.canSelectDocuments = action.payload;
  }
};

export default reducer;
